<template>
  <div style="display: contents">
    <SampleDescriptionGrid :dv="dv" />
    <SequencingLibraryPreparation :dv="dv" />
    <SampleLineageDescription :dv="dv" />
    <ControlSample
      v-if="showControlSection"
      :dv="dv"
      :validation-errors="validationErrors"
    />
    <SingleCellSample
      v-if="showSingleCellSection"
      :dv="dv"
      :validation-errors="validationErrors"
      :hidden-fields="hiddenFields"
    />
    <SampleSpikeIns :dv="dv" />
    <SamplePlate
      v-if="showPlateSection"
      :dv="dv"
      :validation-errors="validationErrors"
    />
    <SampleLinkToELN :dv="dv" />
  </div>
</template>

<script>
import { useSequencingLibraryValidation } from '@/composables/validation/sample/useSampleValidation'
import SampleDescriptionGrid from '../shared/SampleDescriptionGrid.vue'
import SequencingLibraryPreparation from './SequencingLibraryPreparation.vue'
import SampleLineageDescription from '../shared/SampleLineageDescription.vue'
import ControlSample from '../shared/ControlSample.vue'
import SingleCellSample from '../shared/SingleCellSample.vue'
import SampleSpikeIns from './SampleSpikeIns.vue'
import SamplePlate from '../shared/SamplePlate.vue'
import SampleLinkToELN from '../shared/SampleLinkToELN.vue'
export default {
  name: 'SequencingLibrary',
  components: {
    SampleDescriptionGrid,
    SequencingLibraryPreparation,
    SampleLineageDescription,
    ControlSample,
    SingleCellSample,
    SampleSpikeIns,
    SamplePlate,
    SampleLinkToELN,
  },
  props: {
    dv: { type: Object, required: true },
  },
  setup(props) {
    const {
      showControlSection,
      showSingleCellSection,
      showPlateSection,
      validationErrors,
      hiddenFields,
    } = useSequencingLibraryValidation(props.dv)

    return {
      showControlSection,
      showSingleCellSection,
      showPlateSection,
      validationErrors,
      hiddenFields,
    }
  },
}
</script>
